import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import "./detail.scss";
import PdfViewer from "@/assets/PdfViewer.js";
import axiosInstance from "@/axios/axiosInstance";
import tool from "@/assets/tool";
import { useLocation } from "react-router-dom";
const PaperDetailPage = () => {
  const [paperDetail, setDatali] = useState({});
  const [videoImg, setVideoImg] = useState([]);
  const [user, setUser] = useState({});
  let location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const id = queryParams.get("id");
  const profilePictureUrl = queryParams.get("profilePictureUrl");
  const nickName = queryParams.get("nickName");
  useEffect(() => {
    if (id) {
      let user = {
        nickName: nickName,
        profilePictureUrl: profilePictureUrl,
      };
      setUser(user);
      fetchDetails(id); // 如果id存在，
    }
  }, [id]); // 空依赖数组确保只运行一次// 空数组作为依赖项表示这个 effect 只在组件挂载时运行一次
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `paper/page/detail?paperId=${id}`
      );
      document.title = `渐风AI - ${response.data.data.title} ` || "渐风AI";
      setDatali(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    if (paperDetail.userId) {
      getVideoImg();
    }
  }, [paperDetail]);
  useEffect(() => {
    if (paperDetail.userId && videoImg.length > 0) {
      getVideoList();
    }
  }, [videoImg]); // 现在这个 useEffect 会在 videoImg 更新时运行

  const getVideoImg = async () => {
    try {
      const response = await axiosInstance.get(`/sys/image/list?type=7`);
      let videos = response.data.data;
      setVideoImg(videos);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  const getVideoList = async (b) => {
    try {
      const response = await axiosInstance.get(
        `/video/index/list?userId=${paperDetail.userId}`
      );
      let a = response.data.data;
      const bMap = new Map(videoImg.map((item) => [item.id, item.imageUrl]));
      for (let i = 0; i < a.length; i++) {
        if (bMap.has(a[i].cover * 1)) {
          a[i].imageUrl = bMap.get(a[i].cover * 1);
        }
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  return (
    <Layout className="paper_datail">
      <div className="videolist-hea">
        <div className="name">论文教程</div>
        <div></div>
        <div className="name name_titke">{paperDetail.title}</div>
        <div className="name_time">
          {user.nickName} <span>{paperDetail.updateTime}</span>
          <span>来源为用户上传，如有侵权请申诉</span>
        </div>
      </div>
      <div className="content">
        <PdfViewer
          filePath={`${
            paperDetail.contentUrl &&
            paperDetail.contentUrl.split("/file/").length > 1
              ? "/file/" + paperDetail.contentUrl.split("/file/")[1]
              : ""
          }`}
          initialPage={1}
          scale={1}
        />
        <div className="right">
          <div className="top">
            <span>
              <img
                src={`/file/${paperDetail.profilePictureUrl}`}
                alt="author"
                className="avatar"
              />
              <span>
                {paperDetail.nickName || tool.hideMiddleFour(paperDetail.phone)}
              </span>
            </span>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PaperDetailPage;
